<template>
  <div class="agreement">
    <!-- <div class="head">
      <nav-back
        title="推荐须知"
        :titleColor="'#333'"
        :backUrl="require('../../common/images/progress/back_hei.png')"
      />
    </div> -->
    <div class="main">
      <h3 class="title">希望会老带新客户推荐须知</h3>
      <div class="content">
        <p style="font-weight: bold;">重要提示:</p>
        <p class="text">
          1.
          推荐人可在被推荐客户到访项目前30分钟（含本数）在希望会平台进行推荐，少于30分钟或已经到访的属于无效
          推荐。每次推荐有效期90天，90天未到访则可重新推荐。未在90日内到访，或虽到访但登记信息与推荐信息不一致的，属
          于无效推荐。
        </p>
        <p class="text">
          2.
          若推荐前，被推荐人或其联名购买人已被列为该项目客户或被推荐至该项目，则不得重复推荐。希望会平台将根据
          姓名、电话、身份证号等信息进行筛查。
        </p>
        <p class="text">
          3.
          对于有效推荐且被推荐人最终签约购房（付清首付款）的推荐人，具体项目可能会考虑给予一定的奖励，具体是否
          给予奖励及奖励方式等由具体项目根据市场情况制定相应营销政策确定，希望会平台不做任何承诺。
        </p>
        <p class="text">
          4.
          推荐人须如实、完整地填写姓名、手机号码、银行卡账号及开户行等信息，如因推荐人提交的资料错误、不实，导致不
          能成功结算推荐奖励（如有）的后果由推荐人自行承担。
        </p>
        <p class="text">
          5.
          所有项目的推荐奖励标准为税前金额，付款单位将在履行代扣代缴义务后发放税后推荐奖励。若各项目指定代办机构代办
          税费，则推荐人同意无条件配合办理相关手续，例如签署相关委托文件、协议等，否则将无法结付奖励费用。
        </p>
        <p class="text">
          <span style="font-weight: bold;">注：</span
          >本须知所列条件仅为有效推荐的基本条件，推荐成功的具体条件会因被推荐项目的不同而有所区别，请推荐人务必仔细
          阅读具体项目的相关信息，并按照相关要求进行推荐。
        </p>
        <p style="text-indent: 2em;">
          在明确知悉并认可上述条件和要求的基础上，本人自愿推荐购房客户，并同意按照平台要求
          办理相关手续。
        </p>
        <!-- <p style="font-weight: bold;">推荐界面的温馨提示：</p>
        <p class="text">1. 请正确填写被推荐人的姓名及手机号码，且与到访、认购及签约的姓名、手机号码保持一致;</p>
        <p class="text">
          2. 具体推荐政策与奖励等信息以各具体项目营销政策为准，且该政策将不时进行变更，请在推荐前与具体项目沟通确认，希
          望会平台不做任何承诺。
        </p> -->
      </div>
    </div>
  </div>
</template>

<script>
import navBack from '@/components/navBack';
export default {
  components: {
    'nav-back': navBack,
  },
};
</script>

<style lang="scss" scoped>
.agreement {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  .head {
    height: 100px;
    overflow: hidden;
    border-bottom: 0.01rem solid #dddddd;
    .back {
      height: 50px;
      margin-top: 20px;
    }
  }
  .main {
    flex: 1;
    overflow: scroll;
    padding: 20px 30px 80px;
    box-sizing: border-box;
    .title {
      text-align: center;
      font-size: 36px;
    }
    .content {
      p {
        line-height: 38px;
        margin-top: 10px;
      }
      .text {
        text-indent: 1em;
      }
    }
  }
}
</style>
